import FJActionModal from './FJActionModal';
import FJUtil from '../../util/FJUtil';
import FJLimitedCouponStore from '../../store/FJLimitedCouponStore';
import FJConstant from '../../constants/FJConstant.js';
import FJAppConstant from '../../constants/FJAppConstant.js';

const _getEalogFromType = fromType => {
    switch (fromType) {
        case FJConstant.BUSY:
            return 'priority_access';
        case FJConstant.CLOSE:
            return 'original_price_close';
        case FJConstant.DISCOUNT:
            return 'countdown';
        default:
            return '';
    }
};

const FJActionLimitedCoupon = {
    /**
     * @description 打开折扣面板
     * @returns
     */
    openDiscountPanelAction: function (options = {}) {
        return (dispatch, getState) => {
            const appType = getState().common.appType;
            const { fromType } = options;
            const isMobile = FJUtil.isMobile();
            // 手机端没有团队
            const isTeamSpace = isMobile ? false : FJUtil.isTeamSpace();
            const isTeamOwner = isMobile ? false : FJUtil.isTeamOwner();

            if (FJUtil.getAB() === 'A' || appType !== FJAppConstant.IMAGE_TO_IMAGE) {
                dispatch(FJActionModal.showUpgradeModalAction());
            } else {
                const isUsedCoupon = (!isTeamSpace || isTeamOwner) && FJLimitedCouponStore.isUsedCoupon();
                if (isMobile && isUsedCoupon) {
                    FJUtil.eaLog('ai_credits_20%_off_entrance_click', {
                        entrance: _getEalogFromType(fromType),
                    });
                    dispatch(FJActionModal.setTimeDiscountPanelDataAction(true));
                    return;
                }

                if (isUsedCoupon && !isMobile) {
                    FJUtil.eaLog('ai_credits_20%_off_entrance_click', {
                        entrance: _getEalogFromType(fromType),
                    });
                    if (window.openSubscription) {
                        window.openSubscription({
                            panelName: 'Credits',
                            useNewCreditModal: false,
                            useNewCreditModalABtest: false,
                            showCreditRuleTable: false,
                            showQuestionnaire: false,
                            useDisCountCreditsModal: true,
                        });
                        return;
                    }
                }

                // 折扣过期打开升级弹窗
                dispatch(FJActionModal.showUpgradeModalAction());
            }
        };
    },
};

export default FJActionLimitedCoupon;
